const HUD_ACTIONS = {
  HUDS_UPDATED: "HUDS_UPDATED",
  STATISTIC_DEFINITIONS_UPDATED: "STATISTIC_DEFINITIONS_UPDATED",
  STATISTIC_TRANSLATIONS_UPDATED: "STATISTIC_TRANSLATIONS_UPDATED"
};

function HudReducer(state, action) {
  console.log("huds state", state);
  console.log("action", action);
  switch (action.type) {
    case HUD_ACTIONS.HUDS_UPDATED: {
      let _state = JSON.parse(JSON.stringify(state));
      _state.huds = action.payload;
      return _state;
    }
    case HUD_ACTIONS.STATISTIC_DEFINITIONS_UPDATED: {
      let _state = JSON.parse(JSON.stringify(state));
      _state.statisticDefinitions = action.payload;
      return _state;
    }
    case HUD_ACTIONS.STATISTIC_TRANSLATIONS_UPDATED: {
      let _state = JSON.parse(JSON.stringify(state));
      _state.statisticTranslations = action.payload;
      return _state;
    }
    default:
      return state;
  }
}
export { HUD_ACTIONS, HudReducer };
